// TKD-6 / TKD-9: teklif durum ve değişiklik geçmişi (TTSLog.Islem) kodlarının Türkçe etiketleri.
// Bilinmeyen kod olduğu gibi gösterilir (eski 1-5 durumları zaten Türkçe ad taşıyor).

const DURUM = {
  Taslak: "Taslak",
  OnayBekliyor: "Onay bekliyor",
  Onaylandi: "Onaylandı",
  Reddedildi: "Reddedildi",
  DuzeltmeIste: "Düzeltme istendi",
  Gonderildi: "Gönderildi",
  RevizeIstendi: "Revize istendi",
  Kazanildi: "Kazanıldı",
  Kaybedildi: "Kaybedildi",
  Iptal: "İptal",
  SipariseDonustu: "Siparişe dönüştü",
  SuresiDoldu: "Süresi doldu",
  RevizeEdildi: "Revize edildi",
  // YB-11(r): sipariş durumları (Sipariş Dönüşüm raporu vb. ham kod gösteriyordu)
  Hazirlaniyor: "Hazırlanıyor",
};

// YB-11(r): onay (Onaylandi/Reddedildi/DuzeltmeIste) ve müşteri (Kabul/Red/RevizyonTalep) kararları
const KARAR = {
  Onaylandi: "Onaylandı",
  Reddedildi: "Reddedildi",
  DuzeltmeIste: "Düzeltme istendi",
  Kabul: "Kabul edildi",
  Red: "Reddedildi",
  RevizyonTalep: "Revizyon istendi",
};

const ISLEM = {
  TeklifOlustur: "Oluşturuldu",
  OnayaDustu: "Onaya düştü",
  GonderimHazirlandi: "Gönderim hazırlandı",
  BekleyenGonderimGuncellendi: "Bekleyen gönderim güncellendi",
  OnayKarari: "Onay kararı",
  OnayGeriCekildi: "Onaydan geri çekildi",
  Gonderildi: "Müşteriye gönderildi",
  MusteriKarari: "Müşteri kararı",
  KalemEkle: "Kalem eklendi",
  KalemGuncelle: "Kalem güncellendi",
  KalemSil: "Kalem silindi",
  TeklifGuncelle: "Teklif güncellendi",
  TeklifIptal: "İptal edildi",
  TeklifSil: "Teklif silindi",
  RevizeEdildi: "Revize edildi",
  YeniVersiyon: "Yeni versiyon",
  SuresiDoldu: "Süresi doldu",
  SipariseDonustu: "Siparişe dönüştü",
};

export function durumEtiket(kod) {
  if (!kod) return "";
  return DURUM[kod] || kod;
}

export function islemEtiket(kod) {
  if (!kod) return "";
  return ISLEM[kod] || kod;
}

export function kararEtiket(kod) {
  if (!kod) return "";
  return KARAR[kod] || DURUM[kod] || kod;
}

// YB-11(r): BE bildirim başlıkları karar kodunu ham basıyor ("Müşteri kararı: RevizyonTalep",
// "Teklif onay kararı: DuzeltmeIste"); eski kayıtlar da düzelsin diye gösterimde çevrilir.
export function bildirimBaslikEtiket(baslik) {
  if (!baslik) return baslik;
  return String(baslik).replace(/^(Müşteri kararı|Teklif onay kararı):\s*(\S+)\s*$/, function (tam, on, kod) {
    return on + ": " + kararEtiket(kod);
  });
}
